var map = {
	"./hat.png": "4101",
	"./level1.jpg": "051f",
	"./objects/1.png": "c45c",
	"./objects/10.png": "be13",
	"./objects/11.png": "a267",
	"./objects/12.png": "5534",
	"./objects/2.png": "5182",
	"./objects/3.png": "f277",
	"./objects/4.png": "872c",
	"./objects/5.png": "743a",
	"./objects/6.png": "c4f2",
	"./objects/7.png": "30e4",
	"./objects/8.png": "6d16",
	"./objects/9.png": "e6d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "700b";